export class DatiUtenza {
  id;
}
